// @flow
import * as React from "react";
import PairDetailTabs from "../components/PairDetailTabs";

export const CapPairDetail = PairDetailTabs(
  React.lazy(() => import("./containers/PairDetailPage")),
);

/* PAGE HANDLED BY ../PairRoutes.jsx */
